import { useEffect } from 'react';
import Navigation from '../../components/base/Navigation';
import Footer from '../../components/base/Footer';
import CookieBanner from '../../components/base/CookieBanner';
import WhatsAppButton from '../../components/base/WhatsAppButton';

const LegalPage = () => {
  useEffect(() => {
    document.title = 'Aviso Legal - Altta Talent Studio';
  }, []);

  return (
    <div className="min-h-screen bg-[#f7f3f0]">
      <Navigation />
      <main className="pt-20">
        <section className="py-20">
          <div className="container-custom section-padding">
            <div className="max-w-4xl mx-auto bg-white p-8 lg:p-12 rounded-sm shadow-lg">
              <h1 className="text-4xl museo-font text-[#3a3a3a] mb-8 font-medium">
                Aviso Legal
              </h1>
              
              <div className="prose max-w-none text-[#3a3a3a]/90 leading-relaxed space-y-6">
                <h2 className="text-2xl museo-font text-[#3a3a3a] font-medium">
                  Información General
                </h2>
                <p>
                  En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad 
                  de la Información y de Comercio Electrónico, ponemos a su disposición la información general 
                  de este sitio web.
                </p>

                <h3 className="text-xl museo-font text-[#3a3a3a] font-medium">
                  Denominación Social
                </h3>
                <p>Altta Talent Studio</p>

                <h3 className="text-xl museo-font text-[#3a3a3a] font-medium">
                  Domicilio Social
                </h3>
                <p>Paseo de la Independencia 25, 50001 Zaragoza, España</p>

                <h3 className="text-xl museo-font text-[#3a3a3a] font-medium">
                  Contacto
                </h3>
                <p>
                  Email: contacto@alttatalentstudio.com<br />
                  Teléfono: +34 644 221 998
                </p>

                <h2 className="text-2xl museo-font text-[#3a3a3a] font-medium">
                  Objeto
                </h2>
                <p>
                  Altta Talent Studio tiene por objeto la prestación de servicios de representación y gestión 
                  de talento femenino para eventos, producciones y actividades promocionales de alto nivel.
                </p>

                <h2 className="text-2xl museo-font text-[#3a3a3a] font-medium">
                  Condiciones de Uso
                </h2>
                <p>
                  El acceso a este sitio web implica la aceptación de estas condiciones generales de uso. 
                  El usuario se compromete a hacer un uso correcto del sitio web de conformidad con la legislación 
                  aplicable, el presente aviso legal, la moral y buenas costumbres generalmente aceptadas y el orden público.
                </p>

                <h2 className="text-2xl museo-font text-[#3a3a3a] font-medium">
                  Propiedad Intelectual
                </h2>
                <p>
                  Todos los contenidos del sitio web, incluyendo a título enunciativo pero no limitativo, 
                  textos, fotografías, gráficos, imágenes, iconos, tecnología, software, links y demás contenidos 
                  audiovisuales o sonoros, así como su diseño gráfico y códigos fuente, son propiedad de Altta Talent Studio.
                </p>

                <h2 className="text-2xl museo-font text-[#3a3a3a] font-medium">
                  Limitación de Responsabilidad
                </h2>
                <p>
                  Altta Talent Studio no se hace responsable de los daños y perjuicios de cualquier naturaleza 
                  derivados de la falta de disponibilidad o de continuidad del funcionamiento del sitio web, 
                  de la defraudación de la utilidad que los usuarios hubieren podido atribuir al sitio web.
                </p>

                <p className="text-sm text-[#3a3a3a]/70 mt-8">
                  Última actualización: {new Date().toLocaleDateString('es-ES')}
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <CookieBanner />
      <WhatsAppButton />
    </div>
  );
};

export default LegalPage;